let button_element =  document.querySelectorAll('[data-yam-dom-add]');
if(button_element){
	for(let i = 0; i < button_element.length; i++){
		button_element[i].addEventListener('click', function (event) {
			let getElement = event.target.getAttribute('data-yam-dom-add');
			let elements = document.querySelectorAll(getElement);
			let clone = document.querySelector(getElement).cloneNode(true);
			let fotoBlock = clone.querySelector('.blockOutputPhoto');
			if (fotoBlock) {
				fotoBlock.innerHTML = '';
			}
			if($(elements).eq(0).children('.yamLabelFile').children('.filenamePhoto ').hasClass('noValidColor')){
				$(clone).eq(0).children('.yamLabelFile').children('.filenamePhoto ').removeClass('noValidColor')
			};
			clone.value = '';
			//исключаем svg из popup form
			if($(clone).find('.remove-form-file')){
				//console.log($(clone).find('.remove-form-file').length);
				$(clone).find('.remove-form-file').remove();
			}
			$(clone).insertAfter(elements[elements.length - 1]);
			$("body").trigger('ajaxResponse');
		});
	};
};




// WEBPACK FOOTER //
// ./libs/addDomElement.js